export default __webpack_public_path__ + "static/media/empoweredvitality.f3c79144.png";